import { formatFourPlacesCurrency, formatMoneyCurrency, formatVerbatimMoneyCurrency } from '@/shared/utils/formatMoneyDisplay';
import type { MoneyJson } from '@features/products/types/products.types';

export interface PricedPivot {
    pivot: { unit_price_net: string; unit_price_net_money?: MoneyJson };
}

/** The server-rounded unit price verbatim; SMRiQ vendor items and older saved quotes carry no
 *  MoneyResource, so those fall back to formatting the raw pivot price. */
export const formatUnitPriceNet = (item: PricedPivot, currency: string): string => {
    const money = item.pivot.unit_price_net_money;
    return money
        ? formatVerbatimMoneyCurrency(money.amount, money.currency)
        : formatMoneyCurrency(item.pivot.unit_price_net, currency);
};

/** The unit price at its stored four places, so it multiplies back to the allocated line beside it. */
export const formatUnitPriceNetFourPlaces = (item: PricedPivot, currency: string): string =>
    formatFourPlacesCurrency(
        item.pivot.unit_price_net_money?.amount_raw ?? item.pivot.unit_price_net,
        item.pivot.unit_price_net_money?.currency ?? currency,
    );
